import(/* webpackMode: "eager", webpackExports: ["Table","TableBody","TableRow","TableCell"] */ "/Users/yoko/renehuemer.com/website/src/components/ui/table.tsx");
